<div class="element" [class.type]="!!type" [class.state]="!!state" [class]="type || state">
    <ng-content select="[content]"></ng-content>
</div>
